import React from 'react';
import { Spinner } from '@heroui/spinner';
import { Textarea } from '@heroui/input';
import Button from '@/components/NextUI/Button';
import { CancellationSteps } from '@/features/subscription/enum/cancellationSteps';
import { useTranslations } from 'next-intl';

export const OpnionStep = ({
  isSubmitting,
  feedback,
  submissionError,
  planIsLoading,
  setFeedback,
  setStep,
  cancelPlan,
  cancelWithoutFeedback,
}: {
  isSubmitting: boolean;
  feedback: string;
  submissionError: string | null;
  planIsLoading: boolean;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  cancelPlan: () => Promise<void>;
  cancelWithoutFeedback: () => void;
}) => {
  const t = useTranslations('modals.cancel_subscription.steps.opinion');

  return (
    <>
      <div>
        <span className="text-xl font-semibold text-dark">{t('title')}</span>
        <p className="text-gray-medium text-[17px] mt-6">{t('description')}</p>
        <p className="text-gray-medium text-sm mt-2 italic">{t('note')}</p>
      </div>
      <div className="mt-6">
        <Textarea
          value={feedback}
          onValueChange={setFeedback}
          placeholder={t('placeholder')}
          minRows={4}
          className="w-full"
          disabled={isSubmitting}
        />
      </div>
      {submissionError && (
        <p className="text-danger mt-4">
          {t('error_message', { error: submissionError })}
          <br />
          <span className="text-sm">{t('error_note')}</span>
        </p>
      )}
      <div className="flex justify-end gap-4 mt-12 w-full">
        <Button
          variant="outline"
          onClick={() => setStep(CancellationSteps.Reason)}
          disabled={isSubmitting || planIsLoading}
        >
          {t('buttons.back')}
        </Button>
        {submissionError ? (
          <Button onClick={cancelWithoutFeedback} disabled={planIsLoading}>
            {planIsLoading ? (
              <Spinner size="sm" />
            ) : (
              t('buttons.cancel_without_feedback')
            )}
          </Button>
        ) : (
          <Button
            className="w-[203px] !bg-red-light"
            onClick={cancelPlan}
            disabled={isSubmitting || planIsLoading}
            isLoading={isSubmitting}
          >
            {isSubmitting ? '' : t('buttons.confirm_cancellation')}
          </Button>
        )}
      </div>
    </>
  );
};
